module.exports = __webpack_public_path__ + "img/camera02.png";